import React, { PureComponent } from "react";
import Parser from "html-react-parser";

import ContentNoteText from "./styled-components";
import { RenderRichText } from "../../_static/richTextEditorResolver";

class ContentNote extends PureComponent {
  static defaultProps = {
    content: {
      note: "",
      className: undefined
    },
    qaLabel: "contentNote"
  };

  render() {
    const { content, qaLabel } = this.props;

    const listOfContents = [];
    if (typeof content.note !== "string") {
      content.note.content.forEach((blok) => listOfContents.push(blok));
    } else {
      return <ContentNoteText>{Parser(content.note)}</ContentNoteText>;
    }

    return (
      <ContentNoteText className={content.className} data-qa-label={qaLabel}>
        {listOfContents.map((blok) => RenderRichText(blok))}
      </ContentNoteText>
    );
  }
}

export default ContentNote;
